import { toast } from "react-toastify";

export function toastSuccess(texto) {
  return toast(texto, {
    position: "top-right",
    type: "success",
  });
}

export function toastError(texto) {
  return toast(texto, {
    position: "top-right",
    type: "error",
  });
}

export function toastWarning(texto) {
  return toast(texto, {
    position: "top-right",
    type: "warning",
  });
}

export function toastInfo(texto) {
  return toast(texto, {
    position: "top-right",
    type: "info",
  });
}

export function toastDefault(texto) {
  return toast(texto, {
    position: "top-right",
    type: "default",
  });
}
